import * as React from 'react';

const SVGSafety: React.SFC<SvgProps> = props => (
  <svg
    width={18}
    height={22}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M15.9 11c0 7.164-5.884 9.1-6.897 9.38C8.033 20.102 2.1 18.106 2.1 11V5.36L9 1.68l6.9 3.68V11zm.882-6.529l-7.5-4a.596.596 0 0 0-.565 0l-7.5 4A.599.599 0 0 0 .9 5v6c0 8.643 7.885 10.566 7.965 10.584a.56.56 0 0 0 .27 0c.08-.018 7.964-1.941 7.964-10.584V5a.599.599 0 0 0-.317-.529zm-9.929 6.8a.5.5 0 0 0-.707.708l1.875 1.875a.503.503 0 0 0 .777-.089l3.125-5a.499.499 0 1 0-.847-.53l-2.792 4.467-1.43-1.431z"
        id="a"
      />
    </defs>
    <use
      fill="#B0BDC0"
      xlinkHref="#a"
      transform="translate(0 -.358)"
      fillRule="evenodd"
    />
  </svg>
);

export default SVGSafety;
